import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import useScrollPosition from "../scripts/context/hooks/useScrollPosition";

interface Props {
  title: string;
  description: string;
  actionLabel?: string;
  startIcon?: React.ReactElement;
  leftElement?: React.ReactElement;
  action?: () => void;
}

export default function PageTitle({
  title,
  description,
  actionLabel,
  startIcon,
  leftElement,
  action,
}: Props) {
  const isScrolled = useScrollPosition();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1, p: 3,
      }}
    >
      <Box>
        <Typography
          variant="h5"
          color="textPrimary"
          sx={{ fontWeight: "bold" }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </Box>

      {leftElement ? leftElement : action && (
        <Button onClick={action} variant="outlined" startIcon={startIcon}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
